export const REMEMBER_ME = '__rememberMe';
export const PREF_DARK_MODE = '__pref_dark_mode';
export const EXPLICIT_USER_LOGIN_STATUS = '___explicitUserLoginStatus';
export const LOGGED_IN = 'userLoggedIn';
export const LOGGED_OUT = 'userLoggedOut';
export const FETCH_SIGNEDIN_USER_DETAIL = 'fetchSignedInUserDetail';
